
import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { filterEmpty } from './utils'
// ///////////////////////////////////////////////////////
const defaultColors = {
  black: 'black',
  grey: '#CCC',
  white: 'white'
}
// ///////////////////////////////////////////////////////
export const composeBackgroundColorStyles = props => {
  const colors = valueForKeyPath('theme.colors', props) || defaultColors
  const backgroundColor = props.bg ? (props.bg.indexOf('#') > -1 ? props.bg : colors[props.bg]) : null
  return filterEmpty({ backgroundColor })
}
